import { useDemo2Ctx } from '../Demo2Context';
import { TYPE_ICON_RI } from '../demo2Data';

export default function Demo2MHistory() {
    const { workHistory } = useDemo2Ctx();
    const mine = workHistory.filter(h => h.worker === '박현장');
    const totalAmt = mine.reduce((s, h) => s + (parseInt(h.amt) || 0), 0);

    return (
        <>
            <div className="m-header"><div className="m-header-ttl">내 작업 이력</div></div>
            <div className="m-body">
                <div className="m-body-p">
                    <div className="m-kpi-row">
                        <div className="m-kpi"><div className="m-kpi-ico d2-ico-green"><i className="ri-checkbox-circle-line" /></div><div className="m-kpi-val" style={{ fontSize: 15 }}>{mine.length}</div><div className="m-kpi-lbl">완료 건수</div></div>
                        <div className="m-kpi"><div className="m-kpi-ico d2-ico-blue"><i className="ri-drop-line" /></div><div className="m-kpi-val" style={{ fontSize: 15 }}>{totalAmt.toLocaleString()}L</div><div className="m-kpi-lbl">누적 관개량</div></div>
                        <div className="m-kpi"><div className="m-kpi-ico d2-ico-orange"><i className="ri-star-line" /></div><div className="m-kpi-val" style={{ fontSize: 15 }}>4.8</div><div className="m-kpi-lbl">작업 평점</div></div>
                    </div>

                    <div className="m-section-ttl">전체 이력 <span className="cnt">{mine.length}건</span></div>
                    {mine.length === 0 && (
                        <div className="d2-empty">
                            <i className="ri-history-line" />
                            <div className="d2-empty-txt">아직 완료한 작업이 없습니다</div>
                        </div>
                    )}
                    {mine.map((h, i) => {
                        const delta = h.after - h.before;
                        return (
                            <div key={i} className="m-card">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 7 }}>
                                    <span style={{ fontSize: 13, fontWeight: 800, display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span className="d2-ico d2-ico-sm d2-ico-green"><i className={TYPE_ICON_RI[h.type]} /></span>{h.type} · {h.zoneName}
                                    </span>
                                    <span className="badge badge-good">완료</span>
                                </div>
                                <div className="text-xs text-muted" style={{ marginBottom: 9, fontWeight: 600 }}>{h.date}</div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6, fontSize: 11 }}>
                                    <div style={{ background: 'var(--surface2)', borderRadius: 9, padding: '7px 8px' }}><div className="text-muted" style={{ fontSize: 9.5, fontWeight: 600 }}>관개량</div><div style={{ fontWeight: 800 }}>{h.amt}</div></div>
                                    <div style={{ background: 'var(--surface2)', borderRadius: 9, padding: '7px 8px' }}><div className="text-muted" style={{ fontSize: 9.5, fontWeight: 600 }}>시간</div><div style={{ fontWeight: 800 }}>{h.mins}</div></div>
                                    <div style={{ background: 'var(--surface2)', borderRadius: 9, padding: '7px 8px' }}><div className="text-muted" style={{ fontSize: 9.5, fontWeight: 600 }}>수분변화</div><div style={{ fontWeight: 800, color: delta >= 0 ? 'var(--good)' : 'var(--danger)' }}>{h.before}→{h.after}%</div></div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
